// extracted by mini-css-extract-plugin
export default {"catalog__controls":"CatalogBtnControls_catalog__controls__YMMV7"};